import { ProcessAPI } from 'lecom-api';
import FormFieldTypes from 'form/constants/form_field_types';
import DateUtils from 'utils/date_utils';

const serverValueIsDouble = (serverValue) => {
	return typeof serverValue === 'string' && serverValue.match(/^(\d{,3},?)+(\.\d+)?$/);
	//serverValue === 'string' && serverValue.match(/^(\d{0,3},?)+(\.\d+)?$/);
};

const serverValueIsISO8601Date = (serverValue) => {
	return DateUtils.isISO8601Date(serverValue);
};

export const parseServerValue = (serverValue, key, parent) => {	
	if(serverValueIsDouble(serverValue)) {		
		var fieldType = '';

		if ("fieldId" in parent && key === 'value') {
			var fieldId = parent.fieldId;
			var gridId = parent.gridId;

			if (gridId)
				fieldType = ProcessAPI.currentProcess().form().fields(gridId).fields(fieldId).type();
			else
				fieldType = ProcessAPI.currentProcess().form().fields(fieldId).type();
		}

		switch (fieldType) {
			case FormFieldTypes.TEXT:
			case FormFieldTypes.TEXTAREA:
			case FormFieldTypes.CHECKBOX:
				return serverValue;
			default:
				return parseFloat(serverValue.replace(/,/, ''));
		}
	}

	if(serverValueIsISO8601Date(serverValue)) {		
		return DateUtils.convertDateStringToMoment(serverValue);
	}

	return serverValue;
};

export default {
	parseServerValue,
};
